import { Divider, Grid, Typography } from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';

import { type VaSearchInput } from '../../../dtos';
import { type FilterCallback } from '../types';
import { FacetFilterSelect } from './FacetFilterSelect';

type SearchSidebarProps = {
  readonly searchParams: VaSearchInput;
  readonly filterCallback: FilterCallback;
};

export const SearchSidebar: React.FC<SearchSidebarProps> = ({ searchParams, filterCallback }: SearchSidebarProps) => {
  const onStartDateChange = (startDate: Date | null): void => {
    const date = startDate ? new Date(startDate.setHours(0, 0, 0, 0)) : undefined;
    filterCallback({ von: date });
  };

  const onEndDateChange = (endDate: Date | null): void => {
    const date = endDate ? new Date(endDate.setHours(23, 59, 59, 999)) : undefined;
    filterCallback({ bis: date });
  };

  return (
    <div
      style={{
        marginTop: 2,
        paddingLeft: 2,
        paddingRight: 2,
      }}
    >
      <Grid container rowSpacing={2}>
        <Grid size={12} sx={{ mb: -1, mt: 1 }}>
          <Typography variant="paragraph" sx={{ pb: 0.5 }}>
            Filter
          </Typography>
          <Divider />
        </Grid>
        <Grid size={12}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              label="Von"
              format="dd.MM.yyyy"
              value={searchParams.von ?? null}
              onChange={onStartDateChange}
              slotProps={{
                actionBar: { actions: ['clear'] },
                textField: {
                  placeholder: 'Von',
                  sx: { width: '100%' },
                  variant: 'standard',
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid size={12}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              label="Bis"
              format="dd.MM.yyyy"
              value={searchParams.bis ?? null}
              onChange={onEndDateChange}
              slotProps={{
                actionBar: { actions: ['clear'] },
                textField: {
                  placeholder: 'Bis',
                  sx: { width: '100%' },
                  variant: 'standard',
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid size={12}>
          <FacetFilterSelect
            field="sapstatus"
            label="Status"
            searchParams={searchParams}
            filterCallback={filterCallback}
          />
        </Grid>
        <Grid size={12}>
          <FacetFilterSelect
            field="geschaeftsbereich"
            label="Geschäftsbereich"
            searchParams={searchParams}
            filterCallback={filterCallback}
          />
        </Grid>
        <Grid size={12}>
          <FacetFilterSelect
            field="klassifizierung"
            label="Klassifizierung"
            searchParams={searchParams}
            filterCallback={filterCallback}
          />
        </Grid>
        <Grid size={12}>
          <FacetFilterSelect
            field="buchungsnummer"
            label="Buchungsnummer"
            searchParams={searchParams}
            filterCallback={filterCallback}
          />
        </Grid>
        <Grid size={12}>
          <FacetFilterSelect
            field="ortkuerzel"
            label="Ortskürzel"
            searchParams={searchParams}
            filterCallback={filterCallback}
          />
        </Grid>
      </Grid>
    </div>
  );
};
